import { render, staticRenderFns } from "./ValidateDocumentErrorModal.vue?vue&type=template&id=b42e08dc"
import script from "./ValidateDocumentErrorModal.vue?vue&type=script&lang=ts"
export * from "./ValidateDocumentErrorModal.vue?vue&type=script&lang=ts"
import style0 from "./ValidateDocumentErrorModal.vue?vue&type=style&index=0&id=b42e08dc&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports